import { requestJSON } from "./http";

const list = (accessToken) => requestJSON({ path: "/labels", accessToken });

export default {
  list,
};
